<div *ngIf="popoverInformation$ | async as popoverInformation">
  <label>
    <b>Position </b>
    <h3-help-tooltip
      text="XYZ vector describing the camera's position based on extrinsic parameters. Usually represented as Px,Py,Pz."
    ></h3-help-tooltip>
  </label>
  <p>{{ popoverInformation.position.join(', ') }}</p>

  <label>
    <b>Rotation </b>
    <h3-help-tooltip
      text="XYZW quaternion describing the camera's rotation based on extrinsic parameters. Usually represented as Qx,Qy,Qz,Qw."
    ></h3-help-tooltip>
  </label>
  <p>{{ popoverInformation.rotation.join(', ') }}</p>

  <label
    ><b>Focal length </b>
    <h3-help-tooltip
      text="XY vector describing the camera's focal length based on intrinsic parameters. Usually represented as Fx,Fy."
    ></h3-help-tooltip>
  </label>
  <p>{{ popoverInformation.focalLength.join(', ') }}</p>

  <label
    ><b>Field of view </b>
    <h3-help-tooltip
      text="XY vector describe the camera's field of view in degrees. Calculated from the focal length."
    ></h3-help-tooltip>
  </label>
  <p>{{ popoverInformation.fieldOfView.join(', ') }}</p>

  <label
    ><b>Principle point </b>
    <h3-help-tooltip
      text="XY vector describing the camera's principle point based on intrinsic parameters. Usually represented as Cx,Cy."
    ></h3-help-tooltip>
  </label>
  <p>{{ popoverInformation.principlePoint.join(', ') }}</p>

  <br />

  <label>
    <b>Quaternion format corrections </b>
    <h3-help-tooltip
      text="Apply corrections for common errors related to the rotation quaternion's format"
    ></h3-help-tooltip>
  </label>
  @if (optionsStore$ | async; as optionsStore) {
    <div class="radio">
      <label
        ><input
          type="radio"
          name="quaternionTransform"
          value="none"
          [ngModel]="optionsStore.state().quaternionFormatCorrections"
          (ngModelChange)="onQuaternionChange($event)"
        />None</label
      >
    </div>

    <div class="radio">
      <label
        ><input
          type="radio"
          name="quaternionTransform"
          value="xyzwAsWxyz"
          [ngModel]="optionsStore.state().quaternionFormatCorrections"
          (ngModelChange)="onQuaternionChange($event)"
        />XYZW Quaternion inputted as WXYZ</label
      >
    </div>

    <div class="radio">
      <label
        ><input
          type="radio"
          name="quaternionTransform"
          value="wxyzAsXyzw"
          [ngModel]="optionsStore.state().quaternionFormatCorrections"
          (ngModelChange)="onQuaternionChange($event)"
        />WXYZ Quaternion inputted as XYZW</label
      >
    </div>

    <label><b>Transformations</b></label>
    <h3-checkbox
      [ngModel]="optionsStore.state().shouldInvert"
      (ngModelChange)="onShouldInvertChange($event)"
    >
      Invert transformation matrix
    </h3-checkbox>
    <h3-checkbox
      [ngModel]="optionsStore.state().showAxesHelper"
      (ngModelChange)="onShowAxesHelperChange($event)"
    >
      Show camera pose in 3D
    </h3-checkbox>

    <br />

    <label
      ><b>Initial rotation </b>
      <h3-help-tooltip
        text="XYZ Euler angle representing initial rotation on top of which the rotation extrinsic parameter will be applied. Used for correcting data using different axis conventions for rotation. Allowed range is -180 to 180"
      ></h3-help-tooltip>
    </label>

    <br />

    <h3-number-input
      class="rotation-input"
      [min]="-180"
      [max]="180"
      [ngModel]="optionsStore.state().initialRotation[0]"
      (ngModelChange)="onInitialRotationChange($event, 0)"
    ></h3-number-input>
    <h3-number-input
      class="rotation-input"
      [min]="-180"
      [max]="180"
      [ngModel]="optionsStore.state().initialRotation[1]"
      (ngModelChange)="onInitialRotationChange($event, 1)"
    ></h3-number-input>
    <h3-number-input
      class="rotation-input"
      [min]="-180"
      [max]="180"
      [ngModel]="optionsStore.state().initialRotation[2]"
      (ngModelChange)="onInitialRotationChange($event, 2)"
    ></h3-number-input>
  }
</div>
